import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '@/store';
  import { GET_PUBLISH_STATUS, SET_PUBLISH_BAR_DISPLAY } from '@/store/actions/pulse';
  import { PublishStatus } from '@/types/api/pulse';
  import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import ProgressBar from '@/components/ProgressBar.vue';
  import { Colors } from '@/constant/theme';

  
  const __default__ = {
    name: 'ScreenPublishStatus',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const store = useStore();

  const isExpanded = ref(false);
  const intervalId = ref<number | null>(null);
  const hasPendingPublish = ref(true);
  const totalScreens = ref<number>(0);
  const totalPendingScreens = ref<number>(0);
  const totalFailedScreens = ref<number>(0);

  const isPublishBarVisible = computed(() => {
    return store.getters.getShowPublishBar;
  });
  const publishStatus = computed(() => {
    return store.getters.getPublishStatus as Array<PublishStatus>;
  });
  const progressBarColor = computed(() => {
    if (!hasPendingPublish.value && !totalFailedScreens.value) {
      return Colors.GREEN_LIGHT;
    }

    return Colors.PRIMARY_RED;
  });
  const uploadPercent = computed(() => {
    if (totalScreens.value === 0) {
      return 0;
    }

    return ((totalScreens.value - totalPendingScreens.value) * 100) / totalScreens.value;
  });

  watch(publishStatus, () => {
    const pendingPublish = publishStatus.value.filter(
      (pub: PublishStatus) => pub.publishStatus === 'Pending' || !pub.publishStatus,
    );
    const failedPublish = publishStatus.value.filter(
      (pub: PublishStatus) => pub.publishStatus === 'Failed',
    );
    if (pendingPublish.length == 0) {
      hasPendingPublish.value = false;
      destroyTimer();
    }
    totalScreens.value = publishStatus.value.length;
    totalPendingScreens.value = pendingPublish.length;
    totalFailedScreens.value = failedPublish.length;
  });

  watch(isPublishBarVisible, () => {
    if (!isPublishBarVisible.value) {
      destroyTimer();
    }
  });

  onMounted(() => {
    fetchPublishStatus();
    intervalId.value = setInterval(fetchPublishStatus, 5000);
  });

  onUnmounted(() => {
    destroyTimer();
  });

  function closePulseBar() {
    store.dispatch(SET_PUBLISH_BAR_DISPLAY, false);
  }
  function toggleIsExpanded() {
    isExpanded.value = !isExpanded.value;
  }

  async function fetchPublishStatus() {
    await store.dispatch(GET_PUBLISH_STATUS);
  }

  function destroyTimer() {
    if (!intervalId.value) return;
    clearInterval(intervalId.value);
  }

return { __sfc: true,store, isExpanded, intervalId, hasPendingPublish, totalScreens, totalPendingScreens, totalFailedScreens, isPublishBarVisible, publishStatus, progressBarColor, uploadPercent, closePulseBar, toggleIsExpanded, fetchPublishStatus, destroyTimer, BaseText, ProgressBar }
}

})